import { takeEvery } from 'redux-saga/effects';

import * as payoutActions from 'store/modules/payouts';
import { validateFieldValue } from './utils';

export default function* listenSetAccountFieldValue() {
  yield takeEvery(payoutActions.setAccountFieldValue.toString(), validateFieldValue);
}
